<template>
  <el-select
    ref="select"
    :value="value"
    :placeholder="placeholder || '请选择费用项目'"
    :size="size"
    :filterable="filterable"
    :clearable="clearable"
    :disabled="disabled"
    @change="change($event)"
    :style="vstyle"
    default-first-option
    no-data-text="无匹配费用项目"
  >
    <el-option-group
      v-for="group in optionData"
      :key="group.label"
      :label="group.label"
    >
      <el-option
        v-for="item in group.options"
        :key="item.expenseCode"
        :label="item.expenseName"
        :value="item.expenseCode"
      >
      </el-option>
    </el-option-group>
  </el-select>
</template>
<script>
import { request } from '@/api/service'
export default {
  name: 'expense-select',
  props: {
    value: { type: String, default: '' },
    body: { type: Object, default: () => {} },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'small' },
    vstyle: { type: String, default: 'width:100%;' },
    filterable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      data: [],
      optionData: [],
    }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.data.map((o) => [o.expenseCode, o]))
    },
  },
  watch: {
    body() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const params = {
        url: '/master/masterExpense/select',
        method: 'POST',
        data: this.body || {},
      }
      const res = await request(params).catch(() => null)
      if (!res) return
      const { data } = res.body
      this.data = data
      this.optionData = this._dataTransform(data)
      this.$emit('loaded', data)
    },
    _dataTransform(data) {
      const group = []
      data.forEach((item) => {
        const value = item.expenseType
        const label = item.v_expenseType

        const index = group.findIndex((g) => g.value === value)
        if (index >= 0) {
          group[index].options = group[index].options || []
          group[index].options.push(item)
        } else {
          group.push({ value, label, options: [item] })
        }
      })
      return group
    },
    change(val) {
      this.$emit('input', val)
      let selected = this.optionsMap[val]
      this.$emit('change', val, selected)
    },
  },
}
</script>
